import { render, staticRenderFns } from "./PesquisaDentistaModal.vue?vue&type=template&id=5f5a78ce&scoped=true"
import script from "./PesquisaDentistaModal.vue?vue&type=script&lang=js"
export * from "./PesquisaDentistaModal.vue?vue&type=script&lang=js"
import style0 from "./PesquisaDentistaModal.vue?vue&type=style&index=0&id=5f5a78ce&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5a78ce",
  null
  
)

export default component.exports